<template>
  <path
    d="M4.62879 0.213847C4.82911 0.0237699 5.15388 0.0237699 5.35419 0.213847C5.55451 0.403923 5.55451 0.712098 5.35419 0.902175L2.61685 3.49963L12.3913 3.49963C12.6674 3.49963 12.8913 3.72349 12.8913 3.99963C12.8913 4.27577 12.6674 4.49963 12.3913 4.49963L2.6168 4.49963L5.35419 7.09713C5.55451 7.28721 5.55451 7.59538 5.35419 7.78546C5.15388 7.97553 4.82911 7.97553 4.62879 7.78546L1.0018 4.34382C0.801484 4.15374 0.801484 3.84557 1.0018 3.65549L4.62879 0.213847Z"
    fill="currentColor" />
</template>
